@if (variant() === 'ownership') {
  <div class="flex flex-col gap-[10px] w-full">
    <div 
      *ngFor="let item of options.items; let i = index"
      class="box-border w-full border-2 border-solid border-[#14192D] rounded-[4px] py-[11px] px-[20px] hover:bg-gray-50 cursor-pointer transition-all"
      [ngClass]="{
    'border-[#14192D] text-black opacity-100': checkedValue === item.value,       
    'border-gray-300 text-gray-400 opacity-40': checkedValue && checkedValue !== item.value, 
    'border-gray-300 text-gray-400 opacity-60': !checkedValue                   
  }"
    >
      <ark-radio
        [name]="options.name"
        [checked]="checkedValue === item.value"
        [value]="item.value"
        (valueChanged)="selectOption(item.value)"
        [error]="error"
        [errorLabel]="i === options.items.length - 1 ? errorLabel : ''"
        [label]="item.label"
        (infoBubbleClicked)="onInfoBubbleClick(item)"
        [showInfoBubble]="item.value === 'multiple'"
        classes="!mb-0 !w-full"
      ></ark-radio>
    </div>
  </div>
} @else {
  <ark-radio
    *ngFor="let item of options.items; let i = index"
    [name]="options.name"
    [checked]="checkedValue === item.value"
    [value]="item.value"
    (valueChanged)="selectOption(item.value)"
    [error]="error"
    [errorLabel]="i === options.items.length - 1 ? errorLabel : ''"
    [label]="item.label"
    classes="!mb-5"
  ></ark-radio>
}